module.exports = __webpack_public_path__ + "img/left1.4951aea.png";